import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 是否需要触发首页搜索
    triggerHomeSearch: false,
    // 是否需要触发首页搜索（按钮触发）
    triggerHomeSearchForBtn: false,
    // 搜索关键词
    searchKeyword: '',
    // 选择的省份代码
    selectedProvince: "0",
    // 省份简称代码（用于搜索）
    provinceCode: null
  },
  getters: {
    isTriggerHomeSearch(state) {
      return state.triggerHomeSearch;
    },
    isTriggerHomeSearchForBtn(state) {
      return state.triggerHomeSearchForBtn;
    },
    getSearchKeyword(state) {
      return state.searchKeyword;
    },
    getSelectedProvince(state) {
      return state.selectedProvince;
    },
    getProvinceCode(state) {
      return state.provinceCode;
    }
  },
  mutations: {
    // 设置是否需要触发首页搜索
    setTriggerHomeSearch(state, value) {
      state.triggerHomeSearch = value;
    },
    // 设置是否需要触发首页搜索（按钮触发）
    setTriggerHomeSearchForBtn(state, value) {
      state.triggerHomeSearchForBtn = value;
    },
    // 设置搜索关键词
    setSearchKeyword(state, value) {
      state.searchKeyword = value;
    },
    // 设置选择的省份
    setSelectedProvince(state, value) {
      state.selectedProvince = value;
    },
    // 设置省份代码
    setProvinceCode(state, value) {
      state.provinceCode = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
